import { useTranslation } from 'react-i18next'

import GlobeIcon from '@wwt/shared/assets/icons/outline/globe.svg'

import { DropdownMenuItem } from '@/shared/ui/DropdownMenu'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment'

// FIXME: Translations menu item shouldn't be here, we should move it to translations feature
export const TranslationsItem = () => {
	const { t } = useTranslation('header')

	return (
		<UnderDevelopment asChild>
			<DropdownMenuItem data-wwt-id="header__language--button">
				<GlobeIcon />
				{t('menu.language')}
			</DropdownMenuItem>
		</UnderDevelopment>
	)
}
